import { App } from '@capacitor/app';
import { isNativePlatform } from 'services/auth/platform';
import { QueryClient, focusManager } from '@tanstack/react-query';
import type { AxiosError } from 'axios';

const MAX_RETRIES = 2;
const STALE_TIME_MS = 30 * 1000;
const GC_TIME_MS = 5 * 60 * 1000;

const isClientError = (error: unknown): boolean => {
  const status = (error as AxiosError)?.response?.status;
  return typeof status === 'number' && status >= 400 && status < 500;
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: STALE_TIME_MS,
      gcTime: GC_TIME_MS,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      retry: (failureCount, error) => failureCount < MAX_RETRIES && !isClientError(error)
    }
  }
});

export const bindNativeQueryFocus = (): void => {
  if (!isNativePlatform()) return;

  focusManager.setEventListener((handleFocus) => {
    const listener = App.addListener('appStateChange', ({ isActive }) => handleFocus(isActive));
    return () => void listener.then((handle) => handle.remove());
  });
};
